import type { BrandliveEvent, EventListSortType, Session, TranslateString } from "./working-model";

export interface ISeriesPrototype {
	uuid: string;
	channel: number;
	title: string;
	title_translation: TranslateString;
	settings: Record<string, unknown>;
	created_at: Date;
	modified_at: Date | null;
	created_by: number;
	modified_by: number | null;
	events?: SeriesEvent[];
}

export interface ISeriesEventAttendee {
	uuid: string;
	title: string;
	timestamp: string | null;
	end_timestamp: string | null;
	event_image: string | null;
}

export interface ISeriesWithEvents extends ISeriesPrototype {
	events: SeriesEvent[];
}

export interface ICreateSeries {
	channel: number;
	title: string;
	title_translation: TranslateString;
	settings?: Record<string, unknown>;
}

export interface IUpdateSeries {
	uuid: string;
	channel: number;
	title?: string;
	title_translation?: TranslateString;
	settings?: Record<string, unknown>;
}

export interface ISeriesAssociation {
	series_uuid: ISeriesPrototype['uuid'];
	event_uuid: BrandliveEvent['uuid'];
}

export type SeriesEvent =
	Pick<Session, 'title' | 'timestamp' | 'end_timestamp'> &
	Pick<BrandliveEvent, 'uuid' | 'event_image'> &
	{ is_published?: boolean };

export type SeriesEventAttendee = Pick<Session, 'title' | 'timestamp' | 'end_timestamp'> &
	Pick<BrandliveEvent, 'uuid' | 'event_image'>;

export enum ProjectTimeTypes {
	Live = 'Live',
	Upcoming = 'Upcoming',
	All = 'All',
	TestEvents = 'Test Projects',
	Courses = 'Courses',
}

export interface GetProjectOptions {
	pageSize: number;
	sort: EventListSortType;
	searchCriteria: string;
	time: ProjectTimeTypes;
	offset: number;
	append?: boolean;
}